module.exports = __webpack_public_path__ + "img/m1.jpg";